export default __webpack_public_path__ + "static/media/strapi.ac0a6e67.svg";